import React, { useState } from "react";
import "./ResetPasswordModal.css";
import InputBox from "../../../../components/reusable-input/InputBox";
import Button from "../../../../components/reusable-button/Button";
import { AdminUser } from "../../../../apis/adminApis";
import { FiCopy, FiCheck } from "react-icons/fi";

interface Props {
  open: boolean;
  onClose: () => void;
  admin: AdminUser;
  onSubmit: (password: string) => void;
}

const CopyIcon = FiCopy as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const CheckIcon = FiCheck as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const ResetPasswordModal: React.FC<Props> = ({
  open,
  onClose,
  admin,
  onSubmit,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [copiedPassword, setCopiedPassword] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    onSubmit(password);
  };

  const handleCopyPassword = () => {
    navigator.clipboard.writeText(password);
    setCopiedPassword(true);
    setTimeout(() => setCopiedPassword(false), 2000); // revert after 2s
  };

  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal-box">
        <div className="admin-modal-title">
          Reset password for {admin?.firstName} {admin?.middleName}{" "}
          {admin?.lastName}
        </div>
        <form onSubmit={handleSubmit}>
          <div className="password-input-wrapper">
            <div style={{ width: "98%" }}>
              <InputBox
                label="New Password"
                name="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                required
                showPasswordToggle
                showPassword={showPassword}
                onTogglePassword={() => setShowPassword((prev) => !prev)}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "35px",
              }}
            >
              {copiedPassword ? (
                <CheckIcon
                  className="copy-icon"
                  style={{
                    opacity: password ? 1 : 0.4,
                    cursor: password ? "pointer" : "not-allowed",
                  }}
                />
              ) : (
                <CopyIcon
                  className="copy-icon"
                  onClick={password ? handleCopyPassword : undefined}
                  style={{
                    opacity: password ? 1 : 0.4,
                    cursor: password ? "pointer" : "not-allowed",
                  }}
                />
              )}
            </div>
          </div>

          <InputBox
            label="Confirm Password"
            name="confirmPassword"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            type="password"
            required
            showPasswordToggle
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword((prev) => !prev)}
          />

          {error && <div className="admin-error-message">{error}</div>}

          <div className="admin-modal-actions">
            <Button
              label="Cancel"
              type="button"
              variant="outlined"
              onClick={onClose}
            />
            <Button label="Reset" type="submit" variant="solid" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
